export default __webpack_public_path__ + "static/bcore.white.platform.logo.divisions-1486b4d8d004cb6998536d72be52bfb9.png";